import React from 'react';

import cn from '../../../lib/classNames';
import SectionHeader from '../SectionHeader/SectionHeader';

import iconCheck from './images/iconCheck.svg';
import iconQuestion from './images/iconQuestion.svg';
import whySX from './images/whySX.png';

import styles from './WhySafeExplore.module.scss';

type ComparisonItemType = {
	competitor: string;
	safeXplore: string;
};

const comparisonData: ComparisonItemType[] = [
	{ competitor: 'Location-centric data', safeXplore: 'Traveler-centric data' },
	{ competitor: 'Nominal & ordinal scales', safeXplore: 'Rates & ratios scoring' },
	{ competitor: 'Average ratings', safeXplore: 'Demographically specific' },
	{
		competitor: 'National or regional estimates',
		safeXplore: 'City level data (700+ global locations)',
	},
	{ competitor: 'No reference', safeXplore: 'Destination vs home comparison' },
	{ competitor: 'International destinations only', safeXplore: 'US and global coverage' },
	{ competitor: 'Selected crime/incidents risks', safeXplore: 'All personal risks of life & limb' },
	{ competitor: 'Enterprise plans only', safeXplore: 'Custom plan tailored to your needs' },
];

type WhySafeExploreType = {
	classPageContent?: string;
};

const WhySafeExplore = React.forwardRef<HTMLDivElement, WhySafeExploreType>((props, ref) => {
	const { classPageContent } = props;

	return (
		<div ref={ref} className={cn(styles.wrap, classPageContent)}>
			<SectionHeader
				title="Why Safe-xplore?"
				subTitle="We revolutionized the travel risk intelligence industry by solving its biggest flaws. Traditional approaches use arbitrary scales and country-level averages that mask real dangers. Safe-xplore delivers what others can't:"
			/>

			<div className={styles.content}>
				<div className={styles.table}>
					<div className={styles['title-desktop']}>
						<h3 className={styles['title-item']}>Competitors</h3>
						<h3 className={styles['title-item']}>Safe-xplore</h3>
					</div>
					<h3 className={styles['title-mobile']}>Competitors / Safe-xplore</h3>

					{comparisonData.map((item, index) => (
						<div
							key={item.competitor}
							className={cn(styles.row, { [styles.colored]: index % 2 === 0 })}
						>
							<div className={styles.column}>
								<div className={styles.icon}>
									<img src={iconQuestion} alt="?" />
								</div>
								{item.competitor}
							</div>
							<div className={styles.column}>
								<div className={styles.icon}>
									<img src={iconCheck} alt="v" />
								</div>
								{item.safeXplore}
							</div>
						</div>
					))}
				</div>
				<div className={styles.image}>
					<img src={whySX} alt="Why Safe-xplore" />
				</div>
			</div>
			<div className={styles.divider} />
		</div>
	);
});

WhySafeExplore.displayName = 'WhySafeExplore';

export default WhySafeExplore;
